import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { toast } from 'react-toastify'
import {
  useCheckout,
  useCheckoutContext
} from 'lib/modules/checkout'
import { PlaceOrderButton } from 'components/PlaceOrderButton'
import ReCAPTCHA from 'react-google-recaptcha'
import { Container, ReCAPTCHAContainer } from './styled'
import { validateRecaptcha as validateRecaptchaMutation } from 'services/validateRecaptcha'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { getStoreConfig } from 'services/storeConfig'

export const PlaceOrder = (recaptcha: any) => {
  const intl = useIntl()
  const history = useHistory()
  const location = useLocation()
  const isBillingStep = location.pathname === '/checkout/billing'
  const { state } = useCheckoutContext()
  const { paymentMethod } = useCheckout()
  const { code } = paymentMethod
  const {
    validateCheckout,
    isCheckoutLocked,
    billingAddress,
    shippingAddress,
    shippingMethod,
    isPlacingOrder,
    initPaymentMethod,
    setPaymentMethodAndPlaceOrder
  } = useCheckout()
  const isSchemaValid = validateCheckout()
  const isProcessing = isCheckoutLocked || isPlacingOrder
  const isCartWorking =
    isCheckoutLocked ||
    shippingMethod.isFetching ||
    shippingAddress.isFetching ||
    billingAddress.isFetching
  const recaptchaRef = useRef<ReCAPTCHA>(null)
  const [validateRecaptcha] = useMutation(
    validateRecaptchaMutation
  )
  const { loading, data } = useQuery(getStoreConfig)
  const siteKey = data?.storeConfig?.checkoutrecaptcha_general_sitekey

  function handlePlaceOrder () {
    if (isSchemaValid) {
      if (code === 'cashondelivery') {
        setPaymentMethodAndPlaceOrder(code)
      } else {
        initPaymentMethod()
      }
    }
  }

  return !loading ? (
    <Container isWorking={isCartWorking}>
      <PlaceOrderButton
        id='place-order-button'
        onClick={handlePlaceOrder}
        isLoading={isProcessing}
        isDisabled={!isSchemaValid}
        data-submit-btn
        isVisible={isBillingStep && state.isBillingAddressUpdated}
      >
        <>
          {intl.formatMessage({
            id: isProcessing
              ? 'checkout.placeOrder.loading'
              : 'checkout.placeOrder.action.submit'
          })}
        </>
      </PlaceOrderButton>
      <ReCAPTCHAContainer>
        <ReCAPTCHA
          ref={recaptchaRef}
          size='invisible'
          sitekey={siteKey}
          badge='bottomleft'
        />
      </ReCAPTCHAContainer>
    </Container>
  ) : null
}
